//
import {Container,Box,InputLabel,FormControl,InputAdornment,IconButton, OutlinedInput,Typography, Breadcrumbs, Link} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { debounce } from 'lodash';

import React, {useState,useEffect,useCallback} from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
//test
//import Screening from "./Screening";
//import Datatable from "./Datatable";
import CardLayout from "./CardLayout";
import wtsearch from "./search";
import TourDetails from './TourDetails';
// <Datatable data={search(data)} />  
//https://prodwebext2.banffcentre.ca/BanffMountainFestivalAPI/api/WorldTourShow
//https://wt-react-banffcentre.pantheonsite.io/sites/default/files/world_tour/screenings.json
function checkTourDetails(details,term){
  if(details != null){
    const index = details.findIndex(element => {
      return element.Text.includes(term);
    });
    if(index > -1){
      return true;
    }
  }
  return false;

}
function search(data,word){
  //initially term is empty which loads all the screenings
  let term = word.toLowerCase();
 
  const result = data.filter((screening) =>  
    screening.City.indexOf(term) > -1  ||
    wtsearch.searchForProvState(screening.State,term) > -1  ||
    screening.State.indexOf(term) > -1 ||
    screening.Country.indexOf(term) > -1 ||
    screening.TourStartDate.indexOf(term) > -1 ||
    screening.TourEndDate.indexOf(term) > -1 ||
    checkTourDetails(screening.TourDetails,term)

  );
  
  return result;
  
}
function App() {
  
  let searchLabel = "";
  let worldTourNote = "";
  let notice = "Please note: ";
  let searchTermFormat = "";
  const [data, setData] = useState([]);
  const [searchTerm,setSearchTerm] = useState("");
  
  //const [searchColumns, setSearchColumns] = useState([]);
  const currentURL = window.location;
  const origin = currentURL.origin;
  let jsonURL = "https://www.banffcentre.ca/sites/default/files/world_tour/screenings.json";//default is production
  if(origin !== ''){
    jsonURL = origin + '/sites/default/files/world_tour/screenings.json';
  }
  
  //const currentPath = currentURL.pathname;
  //const pathArray = currentPath.split('/');
  //we need to get the region to filter the data by.
  //const region = pathArray[3];
  const region = document.getElementById('root').dataset.region;
  
  let country = '';
  if (region === 'us'){
    country = "usa";
    searchLabel = "Keyword search";
    worldTourNote = "Enter your location or state to find confirmed World Tour screenings near you."
    
  }else if (region === 'ca'){
    country = "canada";
    searchLabel = "Keyword search";
    worldTourNote = "Enter your location or province to find confirmed World Tour screenings near you."
    
  }else if (region === 'int'){
    country = "international";
    searchLabel = "Keyword search";
    //clear the world tour note
    worldTourNote = "Enter your location or country to find confirmed World Tour screenings near you."
    notice = "";
  }else{
    //show everything!
    country = "";
    searchLabel = "Search by City, Country, Date (YYYY-MM-DD)";
  }
  const handleInputChange = (event) => {
    
    setSearchTerm(event.target.value);
  }
  const debouncedChangeHandler = useCallback(debounce(handleInputChange,600),[] );
  
  useEffect(() => {
    
    fetch(jsonURL)
    .then((response) => response.json())
    .then((json) => {

      var lowerCase_json = JSON.parse(JSON.stringify(json, function (a, b) {
        return typeof b === "string" ? b.toLowerCase() : b
      }));
      
      
      //now we want to filter on the region
      const filteredData = lowerCase_json.filter((screening) => {
        
        if(country === 'usa' || country === 'canada'){
          return screening.Country === country;
        }else if(country === 'international'){
          return screening.Region === country;
        }else{
          return screening;
        }
        
      });
      
      if(country === 'international'){
        filteredData.sort((a,b) => {
          let firstScreen = a.Country;
          let secondScreen = b.Country;
          if(firstScreen === ""){
            firstScreen = a.City;
            
          }
          if(secondScreen === ""){
            secondScreen = a.City;
          }
          if(firstScreen < secondScreen){
            return -1;
          }
          if(firstScreen > secondScreen){
            return 1;
          }
          return 0;
        });
      }else{
        filteredData.sort((a,b) => {
          let firstScreen = a.State;
          let secondScreen = b.State;
          if(firstScreen < secondScreen){
            return -1;
          }
          if(firstScreen > secondScreen){
            return 1;
          }
          return 0;
        });        
      }
      
      setData(filteredData);
      
      
      
    })
    .catch((error) => {
      //console.log(error);
    });
  },[country,jsonURL]);//end useEffect()

 
  
  //const columns = data[0] && Object.keys(data[0]);
  //      
  const breadcrumbStyle = {
    fontSize:'1.5rem',
    color:'#404040',
    fontWeight:'bold'
  }
  const separatorStyle = {
    color:'#000'
  }
  
  return (
    <Container className="wtContainer" maxWidth="lg">
      <div className="wtNotice"><span className="wtNoticeTitle">{notice}</span>{worldTourNote}</div>
      <Breadcrumbs separator={<MoreVertIcon fontSize="small" style={separatorStyle}/>} aria-label="breadcrumb" className="wtmenu">
        <Typography style={breadcrumbStyle}>World Tour Locations </Typography>
        <Link underline="none" color="inherit" href="ca" target='_blank'>Canada</Link>
        <Link underline="none" color="inherit" href="us" target='_blank'>
          USA
        </Link>
        <Link underline="none" color="inherit" href="int" target='_blank'>
          International
        </Link>
        <Link underline="none" color="inherit" href="/banffmountainfestival/tour" target='_blank' className="wtHome">World Tour Home</Link>
      </Breadcrumbs>
      
      <FormControl className="searchFieldContainer">
        <InputLabel className="searchInputLabel" htmlFor="searchBox" variant="filled">{searchLabel}</InputLabel>        
        <OutlinedInput id="searchBox" notched={false} className="searchField" autoFocus={true} onChange={debouncedChangeHandler} endAdornment={<InputAdornment position="end"><IconButton edge="end"><SearchIcon /></IconButton></InputAdornment>}/>
      </FormControl>
     
      <hr className="hRule"/>
      <Box sx={{flexGrow:1}} className="searchContainer"> 
        <CardLayout data={search(data,searchTerm)}/>
      </Box>
         
    </Container>
    
  );
  
 
 
}

export default App;
